import queryString from "query-string";
import areArraysIdentical from "@utils/validations/areArraysIdentical";
import computeSortBy from "./computeSortBy";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function isDifferenceOnRouterQuery(
  context,
  routerQuery,
  uiState,
  listingPage,
  personalised,
) {
  const uiStateMainIndex = uiState?.[mainIndex] || {};
  const listingPageSearchQueryKeys = listingPage
    ? Object.keys(queryString.parse(listingPage.search_query, { arrayFormat: "bracket" }))
    : [];

  if (routerQuery.search !== uiStateMainIndex?.query) return true;

  const impliedRouterQueryPage = routerQuery.page ? parseInt(routerQuery.page) : 1;
  const impliedUiStateMainIndexPage = uiStateMainIndex?.page ? parseInt(uiStateMainIndex?.page) : 1;
  if (impliedRouterQueryPage !== impliedUiStateMainIndexPage) return true;

  const impliedRouterQuerySortBy = computeSortBy(context, routerQuery.order_by);
  const impliedUiStateMainIndexSortBy = uiStateMainIndex?.sortBy || mainIndex;
  if (impliedRouterQuerySortBy !== impliedUiStateMainIndexSortBy) return true;

  const impliedRouterQueryBrands = !routerQuery["brands[]"]
    ? []
    : typeof routerQuery["brands[]"] === "string"
      ? [routerQuery["brands[]"]]
      : routerQuery["brands[]"];
  const impliedUiStateMainIndexBrands = uiStateMainIndex.refinementList?.["brand.name"] || [];
  if (
    !listingPageSearchQueryKeys.includes("brands") &&
    !areArraysIdentical(impliedRouterQueryBrands, impliedUiStateMainIndexBrands)
  )
    return true;

  const impliedRouterQueryCategory = !routerQuery["category[]"]
    ? []
    : typeof routerQuery["category[]"] === "string"
      ? [routerQuery["category[]"]]
      : routerQuery["category[]"];
  const impliedRouterQueryClothes = !routerQuery["clothes[]"]
    ? []
    : typeof routerQuery["clothes[]"] === "string"
      ? [routerQuery["clothes[]"]]
      : routerQuery["clothes[]"];
  const impliedRouterQueryAccessories = !routerQuery["accessories[]"]
    ? []
    : typeof routerQuery["accessories[]"] === "string"
      ? [routerQuery["accessories[]"]]
      : routerQuery["accessories[]"];
  const impliedRouterQueryCategoryGrouped = [
    ...impliedRouterQueryCategory,
    ...impliedRouterQueryClothes,
    ...impliedRouterQueryAccessories,
  ];
  const impliedUiStateMainIndexCategory = uiStateMainIndex.refinementList?.category || [];
  if (
    !listingPageSearchQueryKeys.includes("clothes") &&
    !listingPageSearchQueryKeys.includes("accessories") &&
    !listingPageSearchQueryKeys.includes("category") &&
    !areArraysIdentical(impliedRouterQueryCategoryGrouped, impliedUiStateMainIndexCategory)
  )
    return true;

  const impliedRouterQueryColors = !routerQuery["colors[]"]
    ? []
    : typeof routerQuery["colors[]"] === "string"
      ? [routerQuery["colors[]"]]
      : routerQuery["colors[]"];
  const impliedUiStateMainIndexColors = uiStateMainIndex.refinementList?.colors || [];
  if (
    !listingPageSearchQueryKeys.includes("colors") &&
    !areArraysIdentical(impliedRouterQueryColors, impliedUiStateMainIndexColors)
  )
    return true;

  const impliedRouterQueryAvailabilities =
    routerQuery.availabilities === "all" ? ["false", "true"] : ["true"];
  const impliedUiStateMainIndexInStock = uiStateMainIndex.refinementList?.in_stock || [];
  const impliedUiStateMainIndexInStockForC1 =
    uiStateMainIndex.refinementList?.in_stock_for_c1 || [];
  if (
    !listingPageSearchQueryKeys.includes("availabilities") &&
    !routerQuery?.uuid &&
    !areArraysIdentical(impliedRouterQueryAvailabilities, impliedUiStateMainIndexInStock) &&
    !areArraysIdentical(impliedRouterQueryAvailabilities, impliedUiStateMainIndexInStockForC1)
  )
    return true;

  const impliedRouterQueryLegs = !routerQuery["legs[]"]
    ? []
    : typeof routerQuery["legs[]"] === "string"
      ? [routerQuery["legs[]"]]
      : routerQuery["legs[]"];
  const impliedUiStateMainIndexLegs = uiStateMainIndex.refinementList?.legs || [];
  if (
    !listingPageSearchQueryKeys.includes("legs") &&
    !areArraysIdentical(impliedRouterQueryLegs, impliedUiStateMainIndexLegs)
  )
    return true;

  const impliedRouterQuerySeasons = !routerQuery["seasons[]"]
    ? []
    : typeof routerQuery["seasons[]"] === "string"
      ? [routerQuery["seasons[]"]]
      : routerQuery["seasons[]"];
  const impliedUiStateMainIndexSeasons = uiStateMainIndex.refinementList?.season || [];
  if (
    !listingPageSearchQueryKeys.includes("seasons") &&
    !areArraysIdentical(impliedRouterQuerySeasons, impliedUiStateMainIndexSeasons)
  )
    return true;

  const impliedRouterQuerySleeves = !routerQuery["sleeves[]"]
    ? []
    : typeof routerQuery["sleeves[]"] === "string"
      ? [routerQuery["sleeves[]"]]
      : routerQuery["sleeves[]"];
  const impliedUiStateMainIndexSleeves = uiStateMainIndex.refinementList?.sleeves || [];
  if (
    !listingPageSearchQueryKeys.includes("sleeves") &&
    !areArraysIdentical(impliedRouterQuerySleeves, impliedUiStateMainIndexSleeves)
  )
    return true;

  const impliedRouterQueryKinds = !routerQuery["kinds[]"]
    ? []
    : typeof routerQuery["kinds[]"] === "string"
      ? [routerQuery["kinds[]"]]
      : routerQuery["kinds[]"];
  const impliedUiStateMainIndexKinds = uiStateMainIndex.refinementList?.segment || [];
  if (
    !listingPageSearchQueryKeys.includes("kinds") &&
    !areArraysIdentical(impliedRouterQueryKinds, impliedUiStateMainIndexKinds)
  )
    return true;

  const impliedRouterQueryPersonalised = !routerQuery["personalised[]"]
    ? "all"
    : routerQuery["personalised[]"];
  if (impliedRouterQueryPersonalised !== personalised) return true;

  return false;
}
